import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'view-waiver.title',
    defaultMessage: 'Waiver',
  },
  signed: {
    id: 'view-waiver.signed',
    defaultMessage: 'Signed {signedOn, date, short-w-time-2-digit-year}',
  },
  classes: {
    id: 'view-waiver.classes',
    defaultMessage: 'Sessions',
  },
  outOfDate: {
    id: 'view-waiver.outOfDate',
    defaultMessage: 'Out of date',
  },
});
